<template>
  <div class="export-popup">
    <div class="export-popup-title">
      <span>EXPORT DE VOTRE CV</span>
    </div>
    <div class="export-popup-content">
      <label for="export-popup-input">Nom de votre fichier </label>
      <input id="export-popup-input" v-model="exportName" class="text-input" type="text" />
    </div>
    <div class="export-popup-buttons">
      <button class="main-button button-cancel" @click="popupResolve">Annuler</button>
      <a :href="popupData.link" :download="exportName" class="main-button button-create" @click="popupResolve"
        >Exporter</a
      >
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const popupData = computed(() => store.getters['popupData']);
const popupResolve = computed(() => store.getters['popupResolve']);

const exportName = ref(popupData.value.fileTitle + '.' + popupData.value.fileType);
</script>

<style lang="scss" scoped>
.export-popup {
  .export-popup-title {
    width: 100%;
    border-bottom: 2px solid #2d6470;
    padding: 0 0 0.5rem 0;

    > span {
      font-weight: bold;
      font-size: 1.1rem;
      line-height: 1.5rem;
    }
  }

  .export-popup-content {
    display: flex;
    flex-direction: column;
    margin-top: 1.1rem;
    gap: 8px;

    label {
      font-size: 1.1rem;
      line-height: 20px;
    }

    input {
      max-width: 100%;
    }
  }

  .export-popup-buttons {
    display: flex;
    justify-content: center;
    gap: 1.7rem;

    > button,
    a {
      margin-top: 32px;
    }
  }
}
</style>
